import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatourpackage() {



  const cardData = {




keyword: "Pune to Ayodhya Tour Package",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Ayodhya Tour Package for families, devotees, senior citizens, couples, and groups planning a spiritual journey to Ayodhya and other important destinations in North India. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way journeys, round trips, multi-day tours, and customized pilgrimage itineraries. With experienced drivers, clean and well-maintained vehicles, flexible pickup locations, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes long-distance religious travel convenient and comfortable. Travelers can customize their Ayodhya tour to include important temples, ghats, historical attractions, and nearby pilgrimage destinations according to their preferred schedule.",

topPlaces: [
  {
    title: "Ram Mandir Ayodhya",
    description: "Ram Mandir is the principal spiritual attraction in Ayodhya and is an important destination for devotees visiting the city from across India. The temple complex has become a major pilgrimage landmark and is central to many Ayodhya travel itineraries. Travelers booking a Pune to Ayodhya tour package can plan comfortable private transportation with flexible timings for Darshan and visits to nearby religious attractions."
  },
  {
    title: "Hanuman Garhi",
    description: "Hanuman Garhi is a highly revered temple in Ayodhya dedicated to Lord Hanuman and is traditionally visited by pilgrims during their Ayodhya journey. The temple is situated in the heart of the pilgrimage area and is known for its religious significance and distinctive entrance. Garud Cab Service can arrange convenient transportation for families and senior citizens visiting Hanuman Garhi along with other important Ayodhya temples."
  },
  {
    title: "Kanak Bhawan",
    description: "Kanak Bhawan is a beautiful temple in Ayodhya dedicated to Lord Ram and Goddess Sita and is known for its ornate interiors and devotional atmosphere. It is one of the popular religious stops included in Ayodhya sightseeing itineraries. Travelers from Pune can visit Kanak Bhawan comfortably as part of a customized tour package covering the major spiritual attractions of the city."
  },
  {
    title: "Saryu River Ghats",
    description: "The ghats along the Saryu River are an important part of Ayodhya's spiritual landscape and are visited by pilgrims for prayers, rituals, and peaceful moments near the river. Evening activities around the ghats can provide a memorable experience for visitors. A private chauffeur-driven cab allows travelers to conveniently include the Saryu riverfront in their Ayodhya tour itinerary."
  },
  {
    title: "Dasharath Bhavan",
    description: "Dasharath Bhavan is a prominent religious site in Ayodhya associated with King Dasharatha and the Ramayana tradition. The temple and surrounding area attract devotees interested in Ayodhya's spiritual heritage. Families traveling from Pune can include Dasharath Bhavan in their sightseeing schedule while using a comfortable private vehicle for transportation between the city's major attractions."
  },
  {
    title: "Sita Ki Rasoi",
    description: "Sita Ki Rasoi is a traditional religious site in Ayodhya associated with Mata Sita and the Ramayana heritage of the city. The location is visited by devotees as part of their pilgrimage and provides another opportunity to explore Ayodhya's spiritual traditions. Garud Cab Service can include Sita Ki Rasoi in a customized temple tour along with other important religious landmarks."
  },
  {
    title: "Prayagraj",
    description: "Prayagraj is a major pilgrimage city known for the Triveni Sangam, where the Ganga, Yamuna, and traditionally believed Saraswati rivers meet. It is an excellent addition to a longer North India spiritual itinerary from Pune. Travelers can combine Ayodhya and Prayagraj in a multi-day tour package with a private chauffeur-driven vehicle and flexible sightseeing arrangements."
  },
  {
    title: "Varanasi",
    description: "Varanasi is one of India's most important spiritual cities and is famous for the Ganga ghats, Kashi Vishwanath Temple, traditional markets, and evening Ganga Aarti. Many travelers visiting Ayodhya also choose to extend their journey to Varanasi. Garud Cab Service can arrange comfortable multi-day transportation for families and groups covering both pilgrimage destinations."
  },
  {
    title: "Vindhyachal",
    description: "Vindhyachal is an important pilgrimage destination in Uttar Pradesh associated with Goddess Vindhyavasini and attracts devotees throughout the year. The town can be included in an extended religious tour covering Ayodhya, Prayagraj, and Varanasi. A private vehicle provides flexibility for families and groups who want to follow a customized temple itinerary without depending on fixed public transport schedules."
  },
  {
    title: "Chitrakoot",
    description: "Chitrakoot is a spiritually significant destination associated with the Ramayana and is known for temples, sacred sites, forests, and the Mandakini River. It is suitable for travelers looking to explore additional religious destinations after visiting Ayodhya. Customers can customize their Pune to Ayodhya tour package to include Chitrakoot as part of a longer North India pilgrimage journey."
  }
],




"services": [
{
"name": "Pune to Ayodhya Innova Crysta",
"description": "Book Pune to Ayodhya Innova Crysta for a comfortable long-distance journey with spacious seating, air-conditioned interiors, generous luggage space, and professional chauffeur service. The premium MUV is suitable for families, groups, senior passengers, pilgrimage travelers, and customers planning a comfortable road trip to Ayodhya."
},
{
"name": "Pune to Ayodhya Innova Crysta Cab",
"description": "Choose Pune to Ayodhya Innova Crysta Cab for private and comfortable outstation transportation with an experienced chauffeur. Enjoy premium AC travel, spacious seating, convenient luggage capacity, and flexible journey arrangements for Ram Mandir visits, family trips, pilgrimage tours, and extended road travel."
},
{
"name": "Pune to Ayodhya Innova Cab",
"description": "Reserve Pune to Ayodhya Innova Cab for reliable long-distance transportation with comfortable seating and professional chauffeur service. The spacious AC vehicle is suitable for families, devotees, senior travelers, and groups looking for private transportation during their journey from Pune to Ayodhya."
},
{
"name": "Pune to Ayodhya Crysta Taxi Service",
"description": "Book Pune to Ayodhya Crysta Taxi Service for a premium chauffeur-driven journey with comfortable AC interiors and ample luggage space. The service is suitable for families, corporate travelers, tourists, pilgrims, and groups requiring convenient private transportation for a long-distance Ayodhya trip."
},
{
"name": "Innova Crysta on Rent Pune to Ayodhya",
"description": "Hire Innova Crysta on Rent Pune to Ayodhya for a spacious and comfortable chauffeur-driven road journey. Enjoy premium seating, air conditioning, luggage capacity, professional driver service, and flexible travel arrangements suitable for family vacations, pilgrimage tours, Ram Mandir visits, and extended trips."
},
{
"name": "Pune to Ayodhya Innova Booking",
"description": "Make Pune to Ayodhya Innova Booking for convenient private transportation with scheduled pickup and direct destination drop. Select a spacious Innova according to your passenger and luggage requirements and enjoy professional chauffeur service for pilgrimage travel, family journeys, sightseeing, and personal trips."
},
{
"name": "Pune to Ayodhya Luxury Cab",
"description": "Choose Pune to Ayodhya Luxury Cab for a premium and comfortable road journey with spacious seating, clean AC interiors, luggage space, and professional chauffeur service. The service is suitable for families, groups, senior passengers, corporate travelers, and customers seeking enhanced comfort on a long-distance trip."
},
{
"name": "Pune to Ayodhya Innova Hire",
"description": "Hire Pune to Ayodhya Innova with a professional chauffeur for convenient and private long-distance transportation. The vehicle provides comfortable seating, air conditioning, practical luggage capacity, and flexible travel arrangements for families, pilgrims, groups, and travelers planning an extended Ayodhya journey."
},
{
"name": "Pune to Ayodhya Crysta Rental",
"description": "Book Pune to Ayodhya Crysta Rental for premium chauffeur-driven transportation with spacious interiors and comfortable AC travel. The Innova Crysta is suitable for families, groups, senior citizens, tourists, and devotees who require a reliable vehicle for a long-distance pilgrimage or family road trip."
},
{
"name": "Pune to Ayodhya AC Innova Crysta",
"description": "Reserve Pune to Ayodhya AC Innova Crysta for a comfortable journey with climate-controlled interiors, spacious seating, luggage capacity, and professional chauffeur assistance. The premium MUV is suitable for families, senior passengers, tourists, and pilgrimage groups traveling long distances from Pune to Ayodhya."
},
{
"name": "Pune to Ayodhya Innova Crysta Tour Package",
"description": "Choose Pune to Ayodhya Innova Crysta Tour Package for a comfortable private road trip with chauffeur-driven transportation and flexible itinerary planning. Enjoy premium AC travel and spacious seating for family tours, Ram Mandir visits, pilgrimage travel, sightseeing, and extended Ayodhya journeys."
},
{
"name": "Pune to Ayodhya Family Innova Cab",
"description": "Book Pune to Ayodhya Family Innova Cab for a spacious and comfortable family road journey with professional chauffeur service. The Innova provides practical luggage space, comfortable AC seating, and flexible travel arrangements for families, children, senior passengers, and groups visiting Ayodhya."
},
{
"name": "Pune to Ayodhya Round Trip Innova",
"description": "Reserve Pune to Ayodhya Round Trip Innova for convenient return transportation throughout your pilgrimage or sightseeing itinerary. Enjoy private AC travel, spacious seating, professional chauffeur service, and flexible journey planning suitable for families, groups, devotees, and travelers visiting Ayodhya and returning to Pune."
},
{
"name": "Pune to Ayodhya One Way Innova Crysta",
"description": "Book Pune to Ayodhya One Way Innova Crysta for a direct private journey without arranging return transportation. Enjoy premium AC comfort, spacious seating, luggage capacity, and professional chauffeur service suitable for families, pilgrims, senior passengers, and groups traveling from Pune to Ayodhya."
},
{
"name": "Pune to Ayodhya Outstation Innova Cab",
"description": "Choose Pune to Ayodhya Outstation Innova Cab for dependable long-distance transportation with an experienced chauffeur and comfortable AC interiors. The spacious MUV is suitable for family trips, pilgrimage journeys, Ram Mandir visits, group travel, and customers planning a private road trip to Ayodhya."
},
{
"name": "Pune to Ayodhya Premium Cab Service",
"description": "Book Pune to Ayodhya Premium Cab Service for comfortable chauffeur-driven transportation with spacious interiors, air conditioning, practical luggage space, and professional service. Premium vehicle options are suitable for families, groups, senior travelers, tourists, corporate passengers, and pilgrimage travelers."
},
{
"name": "Pune to Ayodhya Online Innova Booking",
"description": "Make Pune to Ayodhya Online Innova Booking for convenient private transportation with scheduled pickup and direct destination drop. Reserve a spacious Innova according to your passenger count, luggage requirements, travel date, and itinerary while enjoying professional chauffeur service throughout the journey."
},
{
"name": "Pune to Ayodhya Ram Mandir Innova Cab",
"description": "Reserve Pune to Ayodhya Ram Mandir Innova Cab for a comfortable pilgrimage journey to Ayodhya with spacious seating and professional chauffeur service. The vehicle is suitable for families, devotees, senior passengers, and groups planning Ram Mandir darshan along with other religious and sightseeing destinations."
},
{
"name": "Pune to Ayodhya Tour Package",
"description": "Choose Pune to Ayodhya Tour Package for a planned private road journey with comfortable chauffeur-driven transportation and flexible travel arrangements. The package can suit families, pilgrims, tourists, and groups visiting Ram Mandir, religious attractions, cultural landmarks, and other destinations in Ayodhya."
},
{
"name": "Ayodhya Tour Package from Pune",
"description": "Book Ayodhya Tour Package from Pune for a convenient long-distance pilgrimage and sightseeing journey with private transportation. Enjoy comfortable AC travel, professional chauffeur assistance, spacious vehicle options, and flexible itinerary planning for families, devotees, tourists, and groups traveling to Ayodhya."
},
{
"name": "Pune to Ayodhya Darshan Package",
"description": "Reserve Pune to Ayodhya Darshan Package for a comfortable private pilgrimage journey planned around temple visits and sightseeing. Travel with professional chauffeur service and spacious AC vehicles suitable for families, senior passengers, devotees, and groups visiting Ram Mandir and other religious attractions."
},
{
"name": "Pune to Ayodhya Ram Mandir Tour",
"description": "Book Pune to Ayodhya Ram Mandir Tour for a convenient private road trip focused on Ram Mandir darshan and Ayodhya sightseeing. Enjoy comfortable AC transportation, professional chauffeur service, flexible pickup, spacious seating, and suitable vehicle options for families, devotees, and groups."
},
{
"name": "Pune to Ayodhya Cab Package",
"description": "Choose Pune to Ayodhya Cab Package for a comfortable chauffeur-driven journey with flexible travel arrangements and private transportation. Select a suitable vehicle according to your group size and luggage requirements for pilgrimage travel, Ram Mandir visits, family tours, sightseeing, and extended road trips."
},
{
"name": "Pune to Ayodhya Online Cab Booking",
"description": "Make Pune to Ayodhya Online Cab Booking for convenient scheduled transportation with private pickup and direct destination drop. Choose a comfortable vehicle according to your passenger count, luggage needs, travel schedule, and preferred comfort level for a long-distance journey to Ayodhya."
},
{
"name": "Pune to Ayodhya Taxi Service",
"description": "Book Pune to Ayodhya Taxi Service for dependable private transportation with experienced chauffeurs and comfortable air-conditioned vehicles. The service is suitable for families, pilgrims, tourists, senior passengers, corporate travelers, and groups planning a long-distance journey between Pune and Ayodhya."
},
{
"name": "Pune to Ayodhya Pilgrimage Tour",
"description": "Choose Pune to Ayodhya Pilgrimage Tour for a comfortable private journey designed for devotees and families visiting important religious destinations. Enjoy chauffeur-driven AC transportation, spacious seating, flexible travel arrangements, and suitable vehicle options for Ram Mandir darshan and Ayodhya sightseeing."
},
{
"name": "Pune to Ayodhya Family Tour Package",
"description": "Book Pune to Ayodhya Family Tour Package for a comfortable and convenient family road trip with private chauffeur-driven transportation. Spacious AC vehicles provide comfortable seating and luggage capacity for families, children, senior passengers, and groups planning Ram Mandir visits, sightseeing, and pilgrimage travel."
}
],
"tableData": [
["Pune to Ayodhya Innova Crysta", "Pune to Ayodhya Innova Crysta Cab"],
["Pune to Ayodhya Innova Cab", "Pune to Ayodhya Crysta Taxi Service"],
["Innova Crysta on Rent Pune to Ayodhya", "Pune to Ayodhya Innova Booking"],
["Pune to Ayodhya Luxury Cab", "Pune to Ayodhya Innova Hire"],
["Pune to Ayodhya Crysta Rental", "Pune to Ayodhya AC Innova Crysta"],
["Pune to Ayodhya Innova Crysta Tour Package", "Pune to Ayodhya Family Innova Cab"],
["Pune to Ayodhya Round Trip Innova", "Pune to Ayodhya One Way Innova Crysta"],
["Pune to Ayodhya Outstation Innova Cab", "Pune to Ayodhya Premium Cab Service"],
["Pune to Ayodhya Online Innova Booking", "Pune to Ayodhya Ram Mandir Innova Cab"],
["Pune to Ayodhya Tour Package", "Ayodhya Tour Package from Pune"],
["Pune to Ayodhya Darshan Package", "Pune to Ayodhya Ram Mandir Tour"],
["Pune to Ayodhya Cab Package", "Pune to Ayodhya Online Cab Booking"],
["Pune to Ayodhya Taxi Service", "Pune to Ayodhya Pilgrimage Tour"],
["Pune to Ayodhya Family Tour Package", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Ayodhya Tour Package with Private Cab",
    WhyChoosedescription: "Garud Cab Service arranges private cab travel from Pune to Ayodhya for families, devotees, senior citizens, and groups planning a religious journey to visit Ayodhya's important temples, spiritual sites, and cultural attractions."
  },
  {
    WhyChooseheading: "Flexible Ayodhya Pilgrimage Itinerary",
    WhyChoosedescription: "Plan your Ayodhya tour around your preferred travel dates, number of days, temple visits, sightseeing requirements, rest periods, and return schedule instead of following a rigid itinerary."
  },
  {
    WhyChooseheading: "Comfortable Travel for Long-Distance Journeys",
    WhyChoosedescription: "For a long-distance pilgrimage such as Pune to Ayodhya, private transportation provides greater control over departure timings, rest breaks, luggage handling, and stops during the journey."
  },
  {
    WhyChooseheading: "Ideal for Families and Devotee Groups",
    WhyChoosedescription: "Families and groups can travel together in a dedicated vehicle selected according to passenger count, luggage requirements, and comfort preferences for their Ayodhya pilgrimage."
  },
  {
    WhyChooseheading: "Explore Ayodhya's Major Religious Places",
    WhyChoosedescription: "The itinerary can include important attractions such as Shri Ram Janmabhoomi, Hanuman Garhi, Kanak Bhawan, Saryu River, Ram Ki Paidi, and other suitable religious and cultural destinations."
  },
  {
    WhyChooseheading: "Senior Citizen-Friendly Travel Planning",
    WhyChoosedescription: "Devotees travelling with elderly family members can plan the journey with suitable rest stops and flexible sightseeing timings, helping make the pilgrimage more comfortable and manageable."
  },
  {
    WhyChooseheading: "Multi-Day Tour Planning",
    WhyChoosedescription: "A multi-day package can be structured according to your chosen route, sightseeing plans, overnight requirements, temple visits, and available vacation period."
  },
  {
    WhyChooseheading: "Arrange Your Ayodhya Trip with Garud",
    WhyChoosedescription: "Share your preferred travel dates, Pune pickup point, number of passengers, vehicle requirement, planned duration, and sightseeing preferences with Garud Cab Service to discuss your Ayodhya tour package."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Ayodhya Tour Packages?",
    answer: "Yes, Garud Cab Service provides customized Pune to Ayodhya tour arrangements for devotees, families, senior citizens, and groups planning a religious or cultural journey."
  },
  {
    question: "Can I customize the Pune to Ayodhya tour itinerary?",
    answer: "Yes, the itinerary can be planned according to your travel dates, number of days, preferred sightseeing places, rest requirements, and return schedule."
  },
  {
    question: "Can I travel from Pune to Ayodhya by private cab?",
    answer: "Yes, private cab travel can be arranged for customers who prefer dedicated transportation and greater flexibility during the long-distance pilgrimage."
  },
  {
    question: "Which places can I visit in Ayodhya?",
    answer: "The tour can include places such as Shri Ram Janmabhoomi, Hanuman Garhi, Kanak Bhawan, Saryu River, Ram Ki Paidi, and other suitable religious and cultural attractions."
  },
  {
    question: "Is the Ayodhya tour suitable for senior citizens?",
    answer: "Yes, the itinerary can be planned with comfortable travel breaks and flexible sightseeing timings to make the journey more convenient for elderly devotees."
  },
  {
    question: "Can families book a private vehicle for the Ayodhya tour?",
    answer: "Yes, families can arrange a dedicated vehicle according to the number of travellers, luggage, and comfort requirements."
  },
  {
    question: "How many days are required for a Pune to Ayodhya tour?",
    answer: "The duration depends on your preferred travel method, sightseeing plans, route, overnight stops, and places you want to visit. A customized itinerary can be discussed based on your available time."
  },
  {
    question: "Can other religious destinations be added to the trip?",
    answer: "Yes, additional religious and sightseeing destinations can be discussed while planning the itinerary, depending on the route and total travel duration."
  },
  {
    question: "Can I arrange pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another convenient location in Pune."
  },
  {
    question: "How can I book a Pune to Ayodhya Tour Package?",
    answer: "Share your travel dates, Pune pickup location, passenger count, preferred vehicle, trip duration, and sightseeing requirements with Garud Cab Service to plan your Ayodhya tour."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Dinesh Patil",
    feedback: "Our family planned an Ayodhya pilgrimage from Pune and chose a private travel arrangement. Being able to plan the journey around our family schedule made the trip much more convenient.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Deshmukh",
    feedback: "We travelled with senior family members for our Ayodhya visit. The flexible itinerary and planned breaks helped us manage the long journey and sightseeing comfortably.",
    rating: 5
  }
];


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ayodhya Tour Package",
  "image": "https://garudcabs.com/assets/images/pune-to-ayodhya-tour-package.webp",
  "description": "Book a comfortable Pune to Ayodhya Tour Package with Garud Cab for a convenient long-distance pilgrimage journey. Travel from Pune to Ayodhya in spacious Innova and Innova Crysta cabs with AC options, luxury cab services, rental, hire, and booking facilities suitable for families, senior citizens, and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-ayodhya-tour-package"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Ayodhya Tour Package | Innova Crysta Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Ayodhya Tour Package with Garud Cab for comfortable and reliable pilgrimage travel. Get Innova Crysta, Innova, luxury, AC, rental, and hire cab services from Pune to Ayodhya with convenient booking options."
  />

  <meta
    name="keywords"
    content="Pune to Ayodhya Innova Crysta, Pune to Ayodhya Innova Crysta Cab, Pune to Ayodhya Innova Cab, Pune to Ayodhya Crysta Taxi Service, Innova Crysta on Rent Pune to Ayodhya, Pune to Ayodhya Innova Booking, Pune to Ayodhya Luxury Cab, Pune to Ayodhya Innova Hire, Pune to Ayodhya Crysta Rental, Pune to Ayodhya AC Innova Crysta"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoayodhyatourpackage;